<template>
	<div class="c-mix-background">
		<img ref="logoRef" :src="logo" alt="" />
	</div>
</template>

<script>
export default {
	data() {
		return {
			logo: ''
		};
	},
	methods: {
		drawLogo(logo) {
			return new Promise((resolve, reject) => {
				const img = this.$refs.logoRef;
				img.addEventListener('load', function () {
					resolve();
				});
				img.crossOrigin = 'Anonymous';
				img.src = logo;
			});
		}
	}
};
</script>

<style lang="less" scoped>
.c-mix-background {
	background: #ffffff;
	width: 100%;
	height: 100%;

	img {
		width: 100%;
		height: 100%;
		object-fit: contain;
		mix-blend-mode: multiply;
	}
}
</style>
